module.exports = __webpack_public_path__ + "static/impulso-bayer-2-44162019bd0e07296070bc3c6b4047a0.jpg";